import { Box } from '@material-ui/core';
import { StepperComponent } from '@roc/client-portal-shared/components';
import { observer } from 'mobx-react';
import { useNewLeadStore } from '../../hooks/useNewLeadStore';
import { useEffect } from 'react';
import { AddContactsToCadenceModal } from './marketing/addContactsToCadenceModal';
import { useStore } from '@roc/client-portal-shared/hooks';
import { SelectCustomProspectsDashboard } from './selectCustomProspectsDashboard';

export const SelectCadenceListStepper = observer(({ handleCloseAddContactsModal, gritStore }) => {
  const { cadenceStore } = useStore();

  return (
    <>
      <Stepper />
      <Box p={4}>
        {(cadenceStore.activeStep === 0) ? (
          <AddContactsToCadenceModal handleCloseModal={handleCloseAddContactsModal} disable={cadenceStore.isAddingMoreProspectsActive} />
        ) : <SelectCustomProspectsDashboard listViewId={cadenceStore.currentDashboardId} gritStore={gritStore} isStandard={cadenceStore.currentDashboardId?.isStandard} handleCloseModal={handleCloseAddContactsModal} />}
      </Box>
    </>
  );
});

const Stepper = () => {
  const { cadenceStore } = useStore();
  const stepNumber = {
    0: 0,
    1: 1,
  }[cadenceStore.activeStep];

  const steps = [
    {
      title: 'Select List',
      icon: null,
      completed: stepNumber > 0,
    },
    {
      title: 'Choose prospects',
      icon: null,
      completed: stepNumber > 1,
    },
  ];

  return (
    <StepperComponent
      activeStep={stepNumber}
      disableNavigation={true}
      steps={steps}
    />
  );
};
